export default "__VITE_ASSET__BO5Vy0tM__"